const LinkCell = ({value, url}) => {
    return (
        <a href={url} target="_blank" rel="noreferrer noopener">{value }</a>
    )
}

export default LinkCell;